import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {useEventTracking} from 'src/hooks/useEventTracking';

import {SecondaryTabs, Tab} from '@pb/kit-component-tabs-v2';


export const LIMITS_SUB_TABS = {
    LIMITS: {name: 'limits', caption: 'Limits'},
    CONNECTOR_LIMITS: {name: 'connector-limits', caption: 'Connector Limits'},
};

type Props = {
    userId: number,
    activeTab: string,
    isConnectorLimitsAllowed: boolean,
};

export const LimitsTabs = ({userId, activeTab, isConnectorLimitsAllowed}: Props) => {
    const navigate = useNavigate();
    const {userTabChange} = useEventTracking();

    const changeTab = useCallback((tab: string) => {
        userTabChange({activeTab: tab, previousTab: activeTab});
        navigate(`/profile/user/${userId}/limits/${tab}`);
    }, [userId, navigate, activeTab, userTabChange]);

    return (
        <SecondaryTabs value={activeTab} onChange={changeTab} className="level-2-tabs" style={{width: '100%'}}>
            {[
                <Tab
                    key="LimitsTab"
                    caption={LIMITS_SUB_TABS.LIMITS.caption}
                    value={LIMITS_SUB_TABS.LIMITS.name}
                />,
                ...isConnectorLimitsAllowed ? [
                    <Tab
                        key="ConnectorLimitsTab"
                        caption={LIMITS_SUB_TABS.CONNECTOR_LIMITS.caption}
                        value={LIMITS_SUB_TABS.CONNECTOR_LIMITS.name}
                    />,
                ] : [],
            ]}
        </SecondaryTabs>
    );
};
